<div class="container" style="padding-top: 25px">
    <div class="row">
        <div class="col">
            <div class="input-group mb-3">
                <input id="user_name" v-model="formData.user" type="text" class="form-control" placeholder="Gracz"
                    aria-label="Gracz" aria-describedby="button-addon2">
                <button class="btn btn-outline-secondary" @click="addUserClick()" type="button" id="button-addon2">Dodaj
                    gracza</button>
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Gracz</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items" :key="item.user_id">
                            <td>{{ item.user_name }}</td>
                            <td><button type="button" @click="deleteUserClick(item.user_id)"
                                    class="btn btn-outline-primary btn-sm">-</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col">
            <div class="input-group mb-3">
                <input id="pnt" type="text" class="form-control" placeholder="Punkty" aria-label="Punkty"
                    aria-describedby="button-addon2" v-model="formData.point">
                <button class="btn btn-outline-secondary" @click="addPointClick()" type="button"
                    id="button-addon2">Dodaj punkty</button>
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Punkty</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="point in points" :key="point.value">
                            <td>{{ point.value }}</td>
                            <td><button type="button" @click="deletePointClick(point.value)"
                                    class="btn btn-outline-primary btn-sm">-</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
        <button type="button" @click="saveToCookies()" class="btn btn-success">Zacznij grę</button>
    </div>
</div>